<template>
    <div v-if="menu.length > 1" class="menu-selection">
        <div v-if="menu.length < 4" class="root-list">
            <button
                v-for="{ id, title }, key in menu"
                :key="`item-${key}-${id}`"
                class="ds-btn ds-btn--flushed tab"
                :aria-label="title"
                :class="{
                    'selected': selected.root === key,
                }"
                @click="selected = { root: key, category: 0 }"
            >
                {{ title }}
            </button>
        </div>
        <div v-else class="root-list short-menu">
            <DSCombobox
                v-model="selected.root"
                :label="$t('selectMenu')"
                :options="computedMenu"
            />
        </div>
        <transition-group
            class="category-list"
            name="button-list"
            tag="div"
        >
            <button
                v-for="{ title, id }, key in menu[selected.root].items"
                :key="`item-${key}-${id}`"
                class="ds-btn ds-btn--secondary"
                :class="{
                    'selected': selected.category === key,
                }"
                @click="selected.category = key"
            >
                {{ title }}
            </button>
        </transition-group>
    </div>
</template>
<script setup>
import { computed, inject, useI18n } from '#imports';

const selected = inject('selected');

const props = defineProps({
    menu: {
        type: Array,
        required: false,
        default: () => [],
    },
});

const computedMenu = computed(() => props.menu.map(item => ({
    value: item.index,
    label: item.title,
})));

defineOptions({
    name: 'CLFoodMenuSelection',
});

useI18n({
    useScope: 'global',
    messages: {
        'fi-FI': {
            selectMenu: 'Valitse kategoria',
        },
        'en-EU': {
            selectMenu: 'Select Category',
        },
        'sv-SE': {
            selectMenu: 'Välj kategori',
        },
    },
});
</script>
<style scoped>
.menu-selection .root-list {
  border-bottom: 1px solid var(--color-base-grey-300);
}
.menu-selection .short-menu {
  max-width: 35rem;
}
.menu-selection .ds-btn.tab {
  transition: all 0.2s ease-in-out;
  position: relative;
  font-weight: 700;
  text-transform: uppercase;
  color: var(--color-base-grey-500);
  padding: 1.5rem 2rem;
  font-size: 1.125rem;
  margin-bottom: -2px;
}
.menu-selection .ds-btn.tab::before {
  transition: all 0.2s ease-in-out;
  content: "";
  background: var(--color-primary-500), 0.13;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  transform-origin: center bottom;
  transform: scaleY(0);
}
.menu-selection .ds-btn.tab::after {
  transition: all 0.2s ease-in-out;
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  height: 0.375rem;
  width: 100%;
  transform: scale(0);
  transform-origin: center center;
}
.menu-selection .ds-btn.tab:hover {
  color: var(--color-primary-900);
}
.menu-selection .ds-btn.tab.selected {
  color: var(--color-primary-900);
  background: var(--color-base-grey-100);
}
.menu-selection .ds-btn.tab.selected::before {
  transform: scaleY(1);
}
.menu-selection .ds-btn.tab.selected::after {
  background: var(--color-primary-500);
  transform: scale(1);
}
.menu-selection .category-list {
  margin: 1rem -0.5rem;
}
.menu-selection .category-list .ds-btn {
  margin-bottom: 0.5rem;
  color: var(--color-base-grey-600);
  font-weight: 700;
  line-height: 2rem;
  margin-left: 0.5rem;
  font-size: 0.875rem;
  padding: 0.25rem 0.5rem;
  border: 1px solid var(--color-base-grey-300);
}
.menu-selection .category-list .ds-btn:hover, .menu-selection .category-list .ds-btn.selected {
  border: 1px solid var(--color-secondary-500);
  color: var(--color-base-black);
  background: var(--color-secondary-500);
}
@media (max-width: 767px) {
  .menu-selection .root-list {
    display: flex;
    flex-flow: column wrap;
  }
  .menu-selection .root-list .ds-btn.tab {
    display: flex;
    justify-content: flex-start;
    padding: 0.75rem 1.5rem;
  }
  .menu-selection .root-list .ds-btn.tab::after {
    width: 4px;
    height: 100%;
    left: 0;
    top: 0;
  }
}
</style>
